import {endpoints} from './endpoints'
import request from '../../request'

export function saveProjectPlanning(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.saveProjectPlanning,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjectPlanning(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectPlanning,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getGeneralProjectPlanning(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getGeneralProjectPlanning,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setGeneralProjectPlanning(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setGeneralProjectPlanning,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}